<h4 class="mb-5">{{ addEdit }} folder</h4>

<div>
	<div>
		<app-input
			class="max-w-350 mb-4"
			label="Folder name"
			[(ngModel)]="folder.title"
			placeholder="Folder name"
		></app-input>
	</div>
</div>

<div class="flex justify-between mt-10">
	<app-button btn="tertiary" class="mr-5" (click)="cancelModal()" size="small"
		>Cancel</app-button
	>
	<app-button size="small" (click)="saveFolder()">{{
		addEdit === 'Add' ? 'Create' : 'Save'
	}}</app-button>
</div>
